import React from 'react';
import PropTypes from 'prop-types';
import { CheckmarkIconSimple } from '@ui/icons';
import { SVGIcon, PillText } from '@web/atoms';
import smilingDogIcon from '../../images/Icons/smiling-dog.svg';
import smilingDogTongueIcon from '../../images/Icons/smiling-dog-with-tongue.svg';
import {
  StyledHappinessQuiz,
  Steps,
  Step,
  IconWrapper,
  SpeechBubble,
} from './styles';

export const HappinessQuizHeader = ({ pillText, currentStep, steps }) => {
  const currentStepIndex = steps.indexOf(currentStep);
  const lastStepIndex = steps.length - 1;

  const getStepIcon = (step, index) => {
    if (index < currentStepIndex) {
      //completed steps
      return (
        <IconWrapper iconColor={'neutral.lightBone'}>
          <CheckmarkIconSimple
            color="status.successPrimary"
            size="18px"
            alt="Completed"
          />
        </IconWrapper>
      );
    } else {
      //check if last step
      if (index === lastStepIndex) {
        if (currentStepIndex === lastStepIndex) {
          //set icon for last step when it's the current step
          return (
            <IconWrapper active={step === currentStep}>
              <SVGIcon
                icon={smilingDogTongueIcon}
                width="26px"
                height="29px"
                viewBox="1 0 30 29"
              ></SVGIcon>
            </IconWrapper>
          );
        } else {
          //Set the icon for the last step when it's not the current step
          return (
            <IconWrapper>
              <SVGIcon
                icon={smilingDogIcon}
                width="28px"
                height="20px"
                viewBox="0 0 28 20"
              ></SVGIcon>
            </IconWrapper>
          );
        }
      }
      //default for non-completed steps
      return (
        <IconWrapper active={step === currentStep} paddingBottom="3px">
          {index + 1}
        </IconWrapper>
      );
    }
  };

  return (
    <StyledHappinessQuiz>
      <PillText text={pillText} variant="kale" />
      <Steps>
        {steps.map((step, index) => (
          <Step key={step} active={step === currentStep}>
            {getStepIcon(step, index)}
            {index === lastStepIndex && currentStepIndex === lastStepIndex && (
              <SpeechBubble>You're almost there!</SpeechBubble>
            )}
            {step}
          </Step>
        ))}
      </Steps>
    </StyledHappinessQuiz>
  );
};

HappinessQuizHeader.displayName = 'HappinessQuizHeader';

HappinessQuizHeader.propTypes = {
  pillText: PropTypes.string,
  currentStep: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};
